import request from "./request";
import config from '@/config'
const baseUrl = config.service.trainUrl

export default {
    getTaskList(planId,userId) {
        return request({
            url: `${baseUrl}/task/pa/data`,
            // url: `http://192.168.0.162:8096/train/task/pa/data`,
            method: 'post',
            data: {
                planId,
                userId
            }
        })
    },
    getGameInfo (taskId){
        let taskUserId = localStorage.getItem("taskUserId")
        let url = `${baseUrl}/task/info?taskId=${taskId}`
        if(taskUserId){
            url += `&taskUserId=${taskUserId}`
        }
        return request.get(url)
    },
    startTask (taskId,sectionId,planId,soundId){
        let taskUserId = localStorage.getItem("taskUserId")
        let params
        if(soundId){
            params = {planId,taskId,sectionId,taskUserId,soundId}
        }else{
            params = {planId,taskId,sectionId,taskUserId}
        }
        return request({
            url:`${baseUrl}/task/start`,
            method: 'post',
            data:params
        })
    },
    commitAnswer(params){
        return request({
            url:`${baseUrl}/question/result/save`,
            method: 'post',
            data:params
        })
    },
    completeTask(params){
        return request({
            url:`${baseUrl}/task/complete`,
            method: 'post',
            data:params
        })
    },
    completeTaskFlex(params){
        return request({
            url:`${baseUrl}/task/flex/complete`,
            method: 'post',
            data:params
        })
    },
	getQybSimpleReport(unionId) {
	  return request({
	    url: `${baseUrl}/report/simple?unionId=${unionId}`,
	    method: 'post'
	  });
	},
	finishTaskRecord(payload) { // 完成任务后记录
	    let url = `${baseUrl}/dynamic_task/record/save`;
	    payload.finished = true;
	    payload.finishProgress = 1;
	    return request({
	        url:url,
	        method: 'post',
	        data:payload
	    })
	},
	progressTaskRecord(dynamicRecord) { // 进度记录
	    let url = `${baseUrl}/dynamic_task/record/save`;
	    return request({
	        url:url,
	        method: 'post',
	        data:dynamicRecord
	    })
	},
	getTaskSetting(code,query,userId) { // 获取任务配置
	    let url = `${baseUrl}/dynamic_task/setting?code=${code}&query=${query}&userId=${userId}`;
	    return request({
	        url:url,
	        method: 'get'
	    })
	},
	createDynamicTaskRecord(dynamicRecord) {  // 创建记录
		let url = `${baseUrl}/dynamic_task/record/save`;
	    dynamicRecord.id = null;
		dynamicRecord.finished = false;
	    dynamicRecord.shared = false;
	    dynamicRecord.resurrectionTimes = null;
	    dynamicRecord.shareTimes = null;
	    dynamicRecord.loginId = null;
	    dynamicRecord.resultShareTimes = 0;
		dynamicRecord.finishProgress =0;
	    console.log('createDynamicTaskRecord   data ====',dynamicRecord)
	    return request({
	        url:url,
	        method: 'post',
	        data:dynamicRecord
	    })
	},
	findSurveryInfoByRecordId(recordId) {  // 创建记录
		let url = `${baseUrl}/dynamic_task/findSurveryInfoByRecordId?recordId=`+recordId;
	    return request({
	        url:url,
	        method: 'get'
	    })
	},
	recentTaskRecord(code,userId,taskUserId) {  // 获取用户历史记录
	    let url = `${baseUrl}/dynamic_task/recent_record?code=${code}&task_user_id=${taskUserId}&user_id=${userId}`;
	    console.log('code',code)
	    console.log('recentTaskRecordtaskUserId',taskUserId)
	    console.log('recentTaskRecorduserId',userId)
	    console.log('recentTaskRecordURL',url)
	    return request({
	        url:url,
	        method: 'get'
	    })
	},
	getTaskUserInfo() {  
	    let url = `${baseUrl}/user/info/task_user_id/by_user_id`;
	    return request({
	        url:url,
	        method: 'get'
	    })
	},
	getSideToolsReportList(unionId){
	    return request({
	        url:`${baseUrl}/report/sideTools/report/list?unionId=`+unionId,
	        method: 'get'
	    })
	},
}
